/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/App/Widget/Error"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Error.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="Oops Sorry."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={12}
 text="We couldn't find what you're looking for."
/>
</div>
{children}
</React.Fragment>)
}